import { Controller } from "@hotwired/stimulus"
import { CurrencyHelper } from "~/helpers/currency_helper"
import { TempFormHelper } from "~/helpers/temp_form_helper"

// This controller is used to remove companies from a list.
export default class extends Controller {
  static get targets() {
    return ["dialogText"]
  }

  static get values() {
    return {
      allSelected: { type: Boolean, default: false },
      selectedCompanyIds: { type: Array, default: [] },
      totalCount: Number,
      listName: String,
    }
  }

  submit({ params: { filterParams } }) {
    let formToSubmit = TempFormHelper.create("/lead/companies/bulks", "put", (form) => {
      TempFormHelper.addHiddenInput(form, "destination_company_list_id", "0")
      TempFormHelper.addHiddenInput(form, "remove_from_list", "true")
      TempFormHelper.addHiddenInput(form, "company_list_id", filterParams["company_list_id"])

      if (this.hasSelectedCompanyIdsValue) {
        this.selectedCompanyIdsValue.forEach(id => TempFormHelper.addHiddenInput(form, "company_ids[]", id))
      }

      if (filterParams) {
        Object.entries(filterParams).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach(arrayValue => {
              TempFormHelper.addHiddenInput(form, `${key}[]`, arrayValue)
            })
          } else {
            TempFormHelper.addHiddenInput(form, key, value)
          }
        })
      }
    })

    formToSubmit.dataset.confirmDialogId = "confirm-remove-from-company-list"
    formToSubmit.dataset.turboConfirm = i18n.t("js.back.lead_actions.remove_from_list")
    formToSubmit.requestSubmit()
  }

  updateSelection(event) {
    this.allSelectedValue = event.detail.allSelected
    this.selectedCompanyIdsValue = event.detail.dataSets.map(dataSet => dataSet.recordId).filter(Boolean)
    const numberOfCompanies = this.allSelectedValue === true ? this.totalCountValue : this.selectedCompanyIdsValue.length
    const companyName = numberOfCompanies === 1 ? event.detail.dataSets[0]?.companyName : false

    if (companyName) {
      this.dialogTextTarget.innerHTML = i18n.t("js.back.company_actions.modal_remove_from_list.description_with_name_html", { company_name: companyName, list_name: this.listNameValue })
    } else {
      this.dialogTextTarget.innerHTML = i18n.t("js.back.company_actions.modal_remove_from_list.description_with_number_html", { count: numberOfCompanies, number_of_companies: CurrencyHelper.numberWithDelimiter(numberOfCompanies), list_name: this.listNameValue })
    }
  }
}
